import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';

@Component({
    selector: 'app-add-requirements-call',
    templateUrl: './add-requirements-call.component.html',
    styleUrls: ['./add-requirements-call.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddRequirementsCallComponent implements OnInit {
	@Input() shooting: any;
	@Input() projectId?: any;
	@Input() categories: any;
	@Input() service: any;
	@Input() hasShooting: boolean = true;
	@Input() lists: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	error: string;
	loading: boolean = false;

	formData: any = {
		'service_category_id': '',
		'vendor': '',
		'description': '',
		'contact_person': '',
		'contact_phone': '',
		'nit': '',
		'quantity': '',
		'call_place': '',
		'call_time': '',
		'arrive': '',
		'wrap': '',
		'cost_unit': '',
		'lunch': '',
		'extra': '',
		'periphery': '',
		'po': '',
		'observation': '',
		'invoice': '',
		'monthly': false,
		'date': null,
		'shooting_id': null,
		'unit_id': ''
	}

	close() {
		this.closeView.emit()
	}
	submitForm() {
		this.loading = true;
		let serviceId = this.service ? this.service.id : null;
		if (this.hasShooting) {
			this.formData.shooting_id = this.shooting ? this.shooting.id : this.service.shooting_schedule_id;
		} else {
			// service without shooting
			this.formData.project_id = this.projectId;
		}
		this._pS.shootingCreateRequimentCall(serviceId, this.formData)
			.subscribe(
				(data: any) => {
					this.loading = false;
					if (data.error) {
						this.error = data.msg;
						return;
					}
					this.notify.emit()
				},
				err => {
					this.loading = false;
				}
			)
	}

	showFields() {
		if (this.shooting) {
			return this.shooting.shooting_shedule_status_id == 2 || this.shooting.shooting_shedule_status_id == 3;
		}
		return true;
	}

	fillForm() {
		this.formData.service_category_id = this.service.service_category_id;
		this.formData.vendor = this.service.vendor;
		this.formData.description = this.service.description;
		this.formData.contact_person = this.service.contact_person;
		this.formData.contact_phone = this.service.contact_phone;
		this.formData.nit = this.service.nit;
		this.formData.quantity = this.service.quantity;
		this.formData.call_place = this.service.call_place;
		this.formData.call_time = this.shooting ? this.service.call_time : this._gS.getStaticStringHour(this.service.call_time);
		this.formData.arrive = this.shooting ? this.service.arrive : this._gS.getStaticStringHour(this.service.arrive);
		this.formData.wrap = this.shooting ? this.service.wrap : this._gS.getStaticStringHour(this.service.wrap);
		this.formData.cost_unit = this.service.cost_unit;
		this.formData.lunch = this.service.lunch;
		this.formData.extra = this.service.extra;
		this.formData.periphery = this.service.periphery;
		this.formData.po = this.service.po;
		this.formData.observation = this.service.observation;
		this.formData.invoice = this.service.invoice;
		this.formData.monthly = this.service.monthly ? true : false;
		this.formData.date = this.service.date ? this.service.date : null;

	}

	constructor(private _pS: ProjetcsService, public _gS: GlobalService, private _fS: FilterService, private datePipe: DatePipe) { }

	ngOnInit() {
		if (this.service) {
			this.fillForm();
		}
	}

}
